/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateFacilityPhysician201Response,
  CreateFacilityPhysician400Response,
  DeleteFacilityPhysician200Response,
  FacilityPhysicianInput,
  FindAllStateTowns200Response,
  FindAllStates200Response,
  SetDefaultFacilityPhysician200Response,
  SetDefaultFacilityPhysicianRequest,
  UpdateFacilityPhoneRequest,
} from '../models/index';
import {
    CreateFacilityPhysician201ResponseFromJSON,
    CreateFacilityPhysician201ResponseToJSON,
    CreateFacilityPhysician400ResponseFromJSON,
    CreateFacilityPhysician400ResponseToJSON,
    DeleteFacilityPhysician200ResponseFromJSON,
    DeleteFacilityPhysician200ResponseToJSON,
    FacilityPhysicianInputFromJSON,
    FacilityPhysicianInputToJSON,
    FindAllStateTowns200ResponseFromJSON,
    FindAllStateTowns200ResponseToJSON,
    FindAllStates200ResponseFromJSON,
    FindAllStates200ResponseToJSON,
    SetDefaultFacilityPhysician200ResponseFromJSON,
    SetDefaultFacilityPhysician200ResponseToJSON,
    SetDefaultFacilityPhysicianRequestFromJSON,
    SetDefaultFacilityPhysicianRequestToJSON,
    UpdateFacilityPhoneRequestFromJSON,
    UpdateFacilityPhoneRequestToJSON,
} from '../models/index';

export interface CreateFacilityPhysicianRequest {
    id: string;
    facilityPhysicianInput: FacilityPhysicianInput;
}

export interface DeleteFacilityPhysicianRequest {
    id: string;
    physicianId: string;
}

export interface FindAllStateTownsRequest {
    stateId: string;
    ids?: string;
    search?: string;
    limit?: number;
    page?: number;
}

export interface SetDefaultFacilityPhysicianOperationRequest {
    id: string;
    setDefaultFacilityPhysicianRequest: SetDefaultFacilityPhysicianRequest;
}

export interface UpdateFacilityPhoneOperationRequest {
    id: string;
    updateFacilityPhoneRequest: UpdateFacilityPhoneRequest;
}

export interface UpdateFacilityPhysicianRequest {
    id: string;
    physicianId: string;
    facilityPhysicianInput: FacilityPhysicianInput;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Create a physician for a facility
     */
    async createFacilityPhysicianRaw(requestParameters: CreateFacilityPhysicianRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFacilityPhysician201Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createFacilityPhysician.');
        }

        if (requestParameters.facilityPhysicianInput === null || requestParameters.facilityPhysicianInput === undefined) {
            throw new runtime.RequiredError('facilityPhysicianInput','Required parameter requestParameters.facilityPhysicianInput was null or undefined when calling createFacilityPhysician.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/facilities/{id}/physicians`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FacilityPhysicianInputToJSON(requestParameters.facilityPhysicianInput),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFacilityPhysician201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a physician for a facility
     */
    async createFacilityPhysician(requestParameters: CreateFacilityPhysicianRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFacilityPhysician201Response> {
        const response = await this.createFacilityPhysicianRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Soft-delete a physician for a facility
     */
    async deleteFacilityPhysicianRaw(requestParameters: DeleteFacilityPhysicianRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteFacilityPhysician200Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteFacilityPhysician.');
        }

        if (requestParameters.physicianId === null || requestParameters.physicianId === undefined) {
            throw new runtime.RequiredError('physicianId','Required parameter requestParameters.physicianId was null or undefined when calling deleteFacilityPhysician.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/facilities/{id}/physicians/{physician_id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"physician_id"}}`, encodeURIComponent(String(requestParameters.physicianId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteFacilityPhysician200ResponseFromJSON(jsonValue));
    }

    /**
     * Soft-delete a physician for a facility
     */
    async deleteFacilityPhysician(requestParameters: DeleteFacilityPhysicianRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteFacilityPhysician200Response> {
        const response = await this.deleteFacilityPhysicianRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get towns by state ID
     */
    async findAllStateTownsRaw(requestParameters: FindAllStateTownsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllStateTowns200Response>> {
        if (requestParameters.stateId === null || requestParameters.stateId === undefined) {
            throw new runtime.RequiredError('stateId','Required parameter requestParameters.stateId was null or undefined when calling findAllStateTowns.');
        }

        const queryParameters: any = {};

        if (requestParameters.ids !== undefined) {
            queryParameters['ids'] = requestParameters.ids;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/states/{state_id}/towns`.replace(`{${"state_id"}}`, encodeURIComponent(String(requestParameters.stateId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllStateTowns200ResponseFromJSON(jsonValue));
    }

    /**
     * Get towns by state ID
     */
    async findAllStateTowns(requestParameters: FindAllStateTownsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllStateTowns200Response> {
        const response = await this.findAllStateTownsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get US states
     */
    async findAllStatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllStates200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/states`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllStates200ResponseFromJSON(jsonValue));
    }

    /**
     * Get US states
     */
    async findAllStates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllStates200Response> {
        const response = await this.findAllStatesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Set or clear the default physician for a facility
     */
    async setDefaultFacilityPhysicianRaw(requestParameters: SetDefaultFacilityPhysicianOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetDefaultFacilityPhysician200Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling setDefaultFacilityPhysician.');
        }

        if (requestParameters.setDefaultFacilityPhysicianRequest === null || requestParameters.setDefaultFacilityPhysicianRequest === undefined) {
            throw new runtime.RequiredError('setDefaultFacilityPhysicianRequest','Required parameter requestParameters.setDefaultFacilityPhysicianRequest was null or undefined when calling setDefaultFacilityPhysician.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/facilities/{id}/physicians/default`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetDefaultFacilityPhysicianRequestToJSON(requestParameters.setDefaultFacilityPhysicianRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetDefaultFacilityPhysician200ResponseFromJSON(jsonValue));
    }

    /**
     * Set or clear the default physician for a facility
     */
    async setDefaultFacilityPhysician(requestParameters: SetDefaultFacilityPhysicianOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetDefaultFacilityPhysician200Response> {
        const response = await this.setDefaultFacilityPhysicianRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a facility phone number
     */
    async updateFacilityPhoneRaw(requestParameters: UpdateFacilityPhoneOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateFacilityPhone.');
        }

        if (requestParameters.updateFacilityPhoneRequest === null || requestParameters.updateFacilityPhoneRequest === undefined) {
            throw new runtime.RequiredError('updateFacilityPhoneRequest','Required parameter requestParameters.updateFacilityPhoneRequest was null or undefined when calling updateFacilityPhone.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/facilities/{id}/phone`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFacilityPhoneRequestToJSON(requestParameters.updateFacilityPhoneRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a facility phone number
     */
    async updateFacilityPhone(requestParameters: UpdateFacilityPhoneOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateFacilityPhoneRaw(requestParameters, initOverrides);
    }

    /**
     * Update a physician for a facility
     */
    async updateFacilityPhysicianRaw(requestParameters: UpdateFacilityPhysicianRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFacilityPhysician201Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateFacilityPhysician.');
        }

        if (requestParameters.physicianId === null || requestParameters.physicianId === undefined) {
            throw new runtime.RequiredError('physicianId','Required parameter requestParameters.physicianId was null or undefined when calling updateFacilityPhysician.');
        }

        if (requestParameters.facilityPhysicianInput === null || requestParameters.facilityPhysicianInput === undefined) {
            throw new runtime.RequiredError('facilityPhysicianInput','Required parameter requestParameters.facilityPhysicianInput was null or undefined when calling updateFacilityPhysician.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/facilities/{id}/physicians/{physician_id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"physician_id"}}`, encodeURIComponent(String(requestParameters.physicianId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FacilityPhysicianInputToJSON(requestParameters.facilityPhysicianInput),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFacilityPhysician201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a physician for a facility
     */
    async updateFacilityPhysician(requestParameters: UpdateFacilityPhysicianRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFacilityPhysician201Response> {
        const response = await this.updateFacilityPhysicianRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
